<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<ng-container>
    <div class="page-wrapper">
        <div class="inner-wrapper inner-wrapper-small">
            <div class="indirect-login-heading"></div>
            <mat-card appearance="raised" class="card mat-elevation-z1">
                <mat-card-content>
                    <div id="loginSuccess" class="login-wrapper">
                        <div class="inner-banner-container">
                           <div *ngIf="partnerId !== lenovoPartner" class="inner-banner-logo-container">
                              <img class="inner-banner-logo" src="assets/Cigent_Logo_Dark_R@4x.png" alt="Company Logo">
                            </div>
                            <div *ngIf="partnerId === lenovoPartner" class="inner-banner-logo-container">
                              <img class="inner-banner-lenovo-logo" src="assets/lenovologo-small-red.png" alt="Company Logo">
                            </div>
                        </div>
                        <div class="icon-wrapper">
                            <div class="icon">
                                <span class="mdi mdi-account"></span>
                            </div>
                            <div class="icon-check">
                                <span class="mdi mdi-check-bold"></span>
                            </div>
                        </div>
                        <div class="title">{{'YOURE_IN' | translate}}</div>
                        <div class="text">{{'YOU_HAVE_SIGNED_IN' | translate}}</div>
                        <div class="button">
                            {{'YOU_MAY_CLOSE_WINDOW' | translate}}
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
          <div class="footer">
            <div>&copy; {{ currentYear }} Cigent Technology Inc.</div>
            <div>{{'ADO_EMAIL' | translate}} <a href="mailto:support@cigent.com" target="_blank" rel="noopener noreferrer">support&#64;cigent.com</a> {{'OR_VISIT_TEXT' | translate}} <a href="https://support.cigent.com/support/home" target="_blank" rel="noopener noreferrer" title="Cigent Support">{{'CIGENT_SUPPORT_LINK_TEXT' | translate}}</a></div>
            <div>Cigent's <a href="https://www.cigent.com/terms" rel="noopener noreferrer" target="_blank">{{'SUBF_TERMS' | translate}}</a> {{'SUBF_AND' | translate}} <a href="https://www.cigent.com/policies" rel="noopener noreferrer" target="_blank">{{'DIV_TOUD' | translate}}</a></div>
          </div>
        </div>
    </div>
</ng-container>
